<template>
  <div class="modal fade" :id="objectModalName.auditTemplate" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.auditTemplate)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content" style="padding: 0 15px">

        <div class="modal-header">
          <h5 class="modal-title">Audit/Review Aufgaben</h5>
          <button type="button" class="close xs-close" data-dismiss="modal" aria-label="Close" @click="closeWarning('#'+objectModalName.auditTemplate)">x</button>
        </div>

        <div class="modal-body">
          <div class="row">
              <div class="table-responsive">
                <table class="table table-bordered mb-4">
                  <thead>
                  <tr>
                    <th class="align-vertical-middle"><input type="checkbox" @change="selectAllTasks($event)"></th>
                    <th class="text-center align-vertical-middle">Name</th>
                    <th class="text-center align-vertical-middle">Beschreibung</th>
                    <th class="text-center align-vertical-middle">Häufigkeit</th>
                    <th class="text-center align-vertical-middle" style="min-width: 130px">Start Datum</th>
                    <th class="text-center align-vertical-middle">Aufwand</th>
                    <th class="text-center align-vertical-middle" style="min-width: 100px">...</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="task in combinedAudits" :key="task.id">
                    <td class="align-vertical-middle">
                      <input type="checkbox" :value="task.id" v-model="selectedTasks" v-if="!auditExists[task.id]">
                      <i class="fa fa-check" v-else style="color: green;"></i>
                    </td>
                    <td class="text-center align-vertical-middle" :class="{'dkl-gray': task.status}">{{ task.name }}</td>
                    <td class="text-center align-vertical-middle" :class="{'dkl-gray': task.status}">{{ task.description }}</td>
                    <td class="text-center align-vertical-middle" :class="{'dkl-gray': task.status}">
                      <span v-if="auditExists[task.id]">
                        {{ task.frequency }} Jahre
                      </span>
                      <div class="input-group" v-else>
                        <input type="text" v-model="task.frequency" class="form-control" name="frequency"/>
                        <div class="input-group-append">
                          <span class="input-group-text" style="padding: 0.2rem !important; font-size: 12px!important;">Jahre</span>
                        </div>
                      </div>
                    </td>
                    <td class="text-center align-vertical-middle" :class="{'dkl-gray': task.status}">
                      <date-picker v-model="task.start_date" :config="datetimeOptions" v-if="!auditExists[task.id]"></date-picker>
                      <span v-else>
                        {{ task.start_date }}
                      </span>
                    </td>
                    <td class="text-center align-vertical-middle" :class="{'dkl-gray': task.status}">
                      <span v-if="auditExists[task.id]">
                        {{ task.duration }} Tage
                      </span>
                      <div class="input-group" v-else>
                        <input type="text" v-model="task.duration" class="form-control" name="duration"/>
                        <div class="input-group-append">
                          <span class="input-group-text" style="padding: 0.2rem !important; font-size: 12px!important;">Tage</span>
                        </div>
                      </div>
                    </td>
                    <td style="vertical-align: middle">
                      <ul class="table-controls" v-if="auditExists[task.id]">
                        <li><a href="javascript:void(0);" class="bs-tooltip" @click.prevent="editAudit(task.id)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2 p-1 br-6 mb-1"><path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path></svg></a></li>
                        <li><a href="javascript:void(0);" class="bs-tooltip" @click.prevent="deleteAudit(task.id)"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash p-1 br-6 mb-1"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg></a></li>
                      </ul>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="border-0 btn btn-primary btn-gradient-primary btn-rounded" @click.prevent="generateAuditTasks" :key="btnEnableKey" :disabled="btnDisabled">Erstellen</button>&nbsp;&nbsp;
          <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.auditTemplate)">Abbrechen</button>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div><!-- modal -->
</template>

<script>
import {service} from '@/utils/request.js';
import {closeWarning, deepCopy} from '@/utils/index.js';
import { objectModalName, newTodo, newAudit } from '@/utils/enums.js';
import {mapState, mapMutations} from 'vuex';
import datePicker from 'vue-bootstrap-datetimepicker';

export default {
  name: "AuditTaskComponent",
  components: {datePicker},
  props: {
    // templateTasks: {
    //   type: Array,
    //   required: true
    // },
  },
  data() {
    return {
      datetimeOptions: {
        format: 'YYYY-MM-DD',
        useCurrent: false,
        allowInputToggle: true,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
        //debug: true
      },
      objectModalName: objectModalName,
      btnEnableKey: 1,
      btnDisabled: false,
      templateTasks: [],
      existingAudits: [],
      editingAudits: [],
      selectedTasks: []
    }
  },
  created() {
    this.getTemplateTasks()
    this.getAudits()
  },
  beforeDestroy() {
  },
  computed: {
    ...mapState({
      accountid: state => state.account.accountid,
      userName: state => state.user.username,
      account: state => state.account,
      userID: state => state.user.id,
      edit: state => state.app.edit,
      modalDirty: state => state.app.modalDirty,
    }),
    existingAuditsName() {
      return this.existingAudits.map(item => item.name.trim())
    },
    combinedAudits() {
      const combinedAudits = deepCopy(this.existingAudits)
      this.templateTasks.forEach(item => {
        if (!this.existingAuditsName.includes(item.name.trim())) combinedAudits.push(item)
      })
      return combinedAudits
    },
    auditExists() {
      if (Object.keys(this.combinedAudits).length === 0) return false
      const auditCheck = {}
      this.combinedAudits.forEach(item => {
        auditCheck[item.id] = this.existingAuditsName.includes(item.name.trim()) && !this.editingAudits.includes(item.id)
      })
      return auditCheck
    }
  },
  methods: {
    ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
    closeWarning,
    editAudit(id) {
      if (!this.editingAudits.includes(id)) {
        this.editingAudits.push(id)
      }
      if (!this.selectedTasks.includes(id)) {
        this.selectedTasks.push(id)
      }
    },
    selectAllTasks(e) {
      if (e.target.checked) {
        this.selectedTasks = this.templateTasks.map(item => item.id)
      } else {
        this.selectedTasks = []
      }
    },
    async generateAuditTasks() {
      const allSettled = Promise.allSettled || ((promises) => Promise.all(
        promises.map(p => p
          .then(value => ({
            status: "fulfilled",
            value
          }))
          .catch(reason => ({
            status: "rejected",
            reason
          }))
        )
      ));
      this.btnDisabled = true
      const audits = []
      const updateAudits = []
      this.selectedTasks.forEach(id => {
        if (!this.editingAudits.includes(id)) {
          let templateTask = this.templateTasks.filter(item => item.id.toString() === id.toString())[0]
          let audit = deepCopy(templateTask)
          audit.customer = this.account.name
          audit.modified_by = this.userName
          audit.id = null
          audit.default_start = audit.start_date
          delete audit.modified
          delete audit.last_finish
          audits.push(audit)
        } else {
          let existingTask = this.combinedAudits.filter(item => item.id.toString() === id.toString())[0]
          updateAudits.push({
            id: existingTask.id,
            default_start: existingTask.start_date,
            frequency: parseInt(existingTask.frequency),
            duration: parseInt(existingTask.duration),
            modified_by: this.userName
          })
        }
      })
      const createPromise = service.request({
        url: 'todos/v1/create_audits/',
        method: 'POST',
        responseType: 'json',
        data: audits
      })
      const allPromises = [createPromise]
      if (updateAudits.length > 0) {
        const updatePromise = service.request({
          url: 'todos/v1/update_multiple_audits/',
          method: 'PUT',
          responseType: 'json',
          data: updateAudits
        })
        allPromises.push(updatePromise)
      }
      allSettled(allPromises)
        .then(allResponses => {
          this.setModalDirty(false)
          this.btnDisabled = false
          let toastMsg = 'Audit Aufgaben sind erfolgreich gespeichert!'
          let status = 'success'
          const createResponse = allResponses[0]
          let updateResponse = false
          if (createResponse.status === 'rejected') {
            toastMsg = createResponse.reason
            status = 'failed'
          } else {
            createResponse.value.data.forEach(item => this.existingAudits.push(item))
          }
          if (allPromises.length > 1) {
            updateResponse = allResponses[1]
            if (updateResponse.status === 'rejected') {
              toastMsg = status === 'success' ? updateResponse.reason : `${toastMsg} ${updateResponse.reason}`
              status = 'failed'
            } else {
              this.editingAudits = []
              updateResponse.value.data.forEach(item => {
                const auditIndex = this.existingAudits.findIndex(existingItem => existingItem.id === item.id)
                this.existingAudits[auditIndex] = item
              })
            }
          }
          if (status === 'success') {
            this.selectedTasks = []
            const updatedValue = updateResponse && updateResponse.value ? updateResponse.value.data : []
            const createdValue = createResponse && createResponse.value ? createResponse.value.data : []
            this.$emit('auditsCreated', {created: createdValue, updated: updatedValue})
            $('#' + this.objectModalName.auditTemplate).modal('hide')
            this.$vToastify.success(toastMsg)
          } else {
            this.$vToastify.error(toastMsg)
          }
        })
    },
    async getTemplateTasks() {
      service.request({
        url: `todos/v1/template_audits/${this.accountid}`,
        method: 'GET',
        responseType: 'json'
      }).then((response) => {
        this.templateTasks = response.data;
        // this.$emit('templateLoaded')
      })
    },
    async getAudits() {
      service.request({
        url: `todos/v1/audits/${this.accountid}/`,
        method: 'GET',
        responseType: 'json'
      }).then((response) => {
        this.existingAudits = response.data;
      })
    },
    // auditExists(audit) {
    //   return this.existingAuditsName.includes(audit.name.trim()) || this.editingAudits.includes(audit.id)
    // }
  }
}
</script>

<style scoped>
.form-control {
  font-size: 13px!important;
}

li {
  display: inline;
}
.close {
  right: 25px;
  top: 20px;
}
</style>
